import styled from '@emotion/styled';

export const StyledHeader = styled('header')(
  () => `
  position: fixed;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 300px);
  height: 75px;
  padding: 0 40px;
  right: 0;
  top: 0;
  z-index: 10;

  .title {
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
  }

  .actions {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .MuiSvgIcon-root {
      color: #000;
    }
  }
`,
);
